var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kt-datatable',_vm._b({ref:"datatable",on:{"change":function($event){return _vm.$emit('filter', $event)}}},'kt-datatable',_vm.datatableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }